import React, { useState } from 'react';
import PlayerCardsContainer from '../Carousel/PlayerCardsContainer';
import CardTableSwitch from './CardTableSwitch';
import SinglePositionTable from './SinglePositionTable';

export default function SinglePositionPlayers({players, positionname}) {
    const [ display, setDisplay ] = useState(0);

    return (<div style={{position: "relative"}}>
        <div style={{position: "absolute",top: '1rem', right: "1rem"}}>
            <CardTableSwitch value={display} setValue={setDisplay} />
        </div>
        {display
        ? <PlayerCardsContainer players={players} hideposition={true} positionname={positionname}/>
        :  <SinglePositionTable players={players} positionname={positionname} />
        }
    </div>)
}